// accordions js start

function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}


function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {  
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });
}
function faq_toggle() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");  
      tabs_title.forEach(togal_tabs);
}
faq_toggle();

// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
// document.addEventListener('click', (e) => {
//   const btn = e.target.closest('.read-more-btn');
//   if (!btn) return;

//   const box = btn.closest('.card-article__entry');

//   box.querySelector('.article-content-short').classList.toggle('hidden');
//   box.querySelector('.article-content-full').classList.toggle('hidden');

//   btn.classList.toggle('is-open');
// });

// TAB JS CODE FOR FAQ

document.addEventListener("DOMContentLoaded", function () {

  const tabItems = document.querySelectorAll(".faq_tab_btn .tablinks");
  const panels = document.querySelectorAll(".panel");

  tabItems.forEach(tab => {
    tab.addEventListener("click", function () {

      const targetSelector = this.getAttribute("data-href");
      const targetPanel = document.querySelector(targetSelector);
      const anchor = this.querySelector("a");

      /* Remove active from all tabs & anchors */
      tabItems.forEach(item => {
        item.classList.remove("active");
        const a = item.querySelector("a");
        if (a) a.classList.remove("active");
      });

      /* Hide all panels */
      panels.forEach(panel => {
        panel.classList.add("hidden");
        panel.classList.remove("active");
      });

      /* Activate clicked tab */
      this.classList.add("active");
      if (anchor) anchor.classList.add("active");

      /* Show matching panel */
      if (targetPanel) {
        targetPanel.classList.remove("hidden");
        targetPanel.classList.add("active");
      }
    });
  });

});

// accordions js end
(function() {
  faq_taggol();
})();


// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 7);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();


// serach in mobile
(function () {
  const stopEvent = (e) => {
    const searchArea = e.target.closest('.search-modal__form');
    if (!searchArea) return;

    e.stopPropagation();
  };

  document.addEventListener('mousedown', stopEvent, true);
  document.addEventListener('click', stopEvent, true);
  document.addEventListener('pointerdown', stopEvent, true);
})();


const heading = document.querySelector('.table-contents .heading');
const content = document.querySelector('.table-contents .content');

if (heading && content) {
  heading.addEventListener('click', () => {
    content.classList.toggle('active');
  });
}

const listItems = document.querySelectorAll('.table-contents ul.menu li');

if (listItems.length && content) {
  listItems.forEach((li) => {
    li.addEventListener('click', () => {
      content.classList.remove('active');
    });
  });
}



// upsell cart drawer atc
function handleCustatcBtnClick(This) {     
      const selectedVariantId = parseInt(This.getAttribute("data-variantid")) || null;
      console.log("selectedVariantId",selectedVariantId,"This",This)
      if(!selectedVariantId) return;
      const cartDrawer = document.querySelector('cart-drawer');
      console.log("cartDrawer",cartDrawer);
      const addProductToCart = async () => {
        try {         

          const formData = new FormData();
          formData.append('id', selectedVariantId);
          formData.append('quantity', 1);        
          formData.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              ?.map(section => section.section)
          );                   

          let sectionsToRender = [];
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            sectionsToRender = cartDrawer.getSectionsToRender()?.map(s => s.section) || [];
          } else {
            const mainCartItems = document.getElementById('main-cart-items');
            if (mainCartItems && mainCartItems.dataset && mainCartItems.dataset.id) {
              sectionsToRender.push(mainCartItems.dataset.id);
            }
            sectionsToRender.push('cart-counter');
          }

          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const addToCartResponse = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const addToCartData = await addToCartResponse.json();
          console.log("addToCartData",addToCartData);

          if (!addToCartResponse.ok) {
            throw new Error(addToCartData.description);
          }         

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            console.log("cartDrawer",cartDrawer)
            cartDrawer?.renderContents(addToCartData, true);
          }
          
        } catch (error) {
        console.error("error",error);
        } finally {  
          console.log("finallyy")                                    
        }
      };

      addProductToCart();
    }


function closeButtonDrawer(This){
  const parent_summary = This.closest("header-drawer");
  const  all_summary = parent_summary.querySelector("details .accordion__section.is-active summary");
  const details = all_summary?.closest("details");
  if (!all_summary) return;
  all_summary.click();
    
  if (details) {
    details.open = false;
    details.classList.remove("is-active");

    const body = details.querySelector(".accordion__body");
    body?.classList.remove("is-transitioning");
    body?.removeAttribute("style");
  }

} 

// copy code js
 const copybtn = document.querySelector(".copy-code-right");
 copybtn?.addEventListener("click", function (copytext) {
      let codeText = copybtn.innerHTML;      
      navigator.clipboard.writeText(codeText).then(() => {
        let originalText = copybtn.innerHTML; 
        copybtn.innerHTML = "&#10003;";        
        setTimeout(() => {
          copybtn.innerHTML = originalText;
        }, 2000);
      }).catch(err => {
        console.error("Copy failed", err);
      });
  });



  // shoe moew and less option in card product

  function show_option(button_more) {

      const parent_options = button_more.closest("fieldset");
      const remaning_options = parent_options.querySelectorAll(".extra_options.hidden");
      remaning_options?.forEach(el => el.classList.remove("hidden"));
      button_more.classList.add("hidden")
   
  }